<template>
  <div class="h-full flex-auto flex justify-center items-center mx-auto">
    <div class="bg-white shadow-xl">

        <div class="bg-gray-600 text-white p-4 text-lg font-bold">
          Endre universitet
        </div>

        <form @submit.prevent="doSubmit" class="p-10" v-if="university">

          <div class="flex items-center justify-between mt-6">
            <label class="font-bold w-40" for="name">Navn</label>
            <input class="ml-6 w-64" type="text" id="name" v-model="university.name" ref="name" required :class="{'invalid': errors.Name }">
          </div>

          <div class="flex items-center justify-between mt-6">
            <label class="font-bold w-40" for="name">Praksiskoordinator</label>
            <select class=" w-64" v-model="university.userId">
              <option v-for="user in users" :key="user.userId" :value="user.userId">
                {{ user.name }}
              </option>
            </select>
          </div>

          <div class="text-center mt-12">
            <button type="submit" class="btn btn-primary mx-2">Lagre</button>
            <router-link class="btn mx-2" to="/af/studiesteder">Avbryt</router-link>
          </div>

        </form>

    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'ap-university-update',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      errors: [],
      university: null,
      users: []
    }
  },
  methods: {
    async doSubmit () {
      const response = await api.af.updateUniversity(this.university)
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$toasted.show('Studiested lagret!')
        this.$router.push('/af/studiesteder')
      }
    }
  },
  async mounted () {
    this.university = await api.af.getUniversity(this.id)
    this.users = await api.af.getUsersByRole(1)
    this.$nextTick(() =>  this.$refs.name.focus()) // ref in inside a v-if'
  }
}
</script>

